export enum RenderSettings {
  skipEmptySpace = 'skipEmptySpace',
  askPublishOutputName = 'askPublishOutputName',
  closePublishSettingsOnCancel = 'closePublishSettingsOnCancel',
}

export enum BehaviourSettings {
  setTimecodeFormatBasedOnMedia = 'setTimecodeFormatBasedOnMedia',
  muteAudioAtCreatedLayers = 'muteAudioAtCreatedLayers',
  preventVideoAddToTimelineOnMismatch = 'preventVideoAddToTimelineOnMismatch',
  askProjectNameOnNewProject = 'askProjectNameOnNewProject',
  addFirstImportAtStartTC = 'addFirstImportAtStartTC',
  allowTimelineAndMediaLayoutChange = 'allowTimelineAndMediaLayoutChange',
  useModalDialogForImportLocalFiles = 'useModalDialogForImportLocalFiles',
  preventAddVideoFilesWDiffVideoEncoderParams = 'preventAddVideoFilesWDiffVideoEncoderParams',
  ignoreQuantizerVideoParamsMismatch = 'ignoreQuantizerVideoParamsMismatch',
  autoPlaySelectedMedia = 'autoPlaySelectedMedia'
}

export enum ViewSettings {
  showHeader = 'showHeader',
  showMenuTabs = 'showMenuTabs',
  showProjectMedia = 'showProjectMedia',
  showMyMedia = 'showMyMedia',
  showPreviewSplitButton = 'showPreviewSplitButton',
  showPreviewSwitchButtons = 'showPreviewSwitchButtons',
  showInOutPointsTimeline = 'showInOutPointsTimeline',
  showInOutPointsSource = 'showInOutPointsSource',
  showDropPlaceHolderTimeline = 'showDropPlaceHolderTimeline',
  lang = 'lang',
}

export const RENDER_FORM_STATE = {
  skipEmptySpace: __CFG__.RENDER_SETTINGS.SKIP_EMPTY_SPACE || 0,
  askPublishOutputName: __CFG__.RENDER_SETTINGS.ASK_PUBLISH_OUTPUT_NAME ?? 1,
  closePublishSettingsOnCancel: __CFG__.SAVE_SETTINGS.CLOSE_ON_CANCEL ? 1 : 0,
} as const

export const BEHAVIOUR_FORM_STATE = {
  setTimecodeFormatBasedOnMedia: __CFG__.BEHAVIOUR_SETTINGS.SET_TIMECODE_FORMAT_BASED_ON_MEDIA || 0,
  muteAudioAtCreatedLayers: __CFG__.BEHAVIOUR_SETTINGS.MUTE_AUDIO_AT_CREATED_LAYERS || 0,
  preventVideoAddToTimelineOnMismatch: __CFG__.BEHAVIOUR_SETTINGS.PREVENT_VIDEO_ADD_TO_TIMELINE_ON_MISMATCH || 0,
  askProjectNameOnNewProject: __CFG__.BEHAVIOUR_SETTINGS.ASK_PROJECT_NAME_ON_NEW_PROJECT || 0,
  addFirstImportAtStartTC: __CFG__
    .BEHAVIOUR_SETTINGS.ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE || 0,
  allowTimelineAndMediaLayoutChange: __CFG__
    .BEHAVIOUR_SETTINGS.ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE || 0,
  useModalDialogForImportLocalFiles: __CFG__
    .IMPORT.USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES || 0,
  preventAddVideoFilesWDiffVideoEncoderParams: __CFG__
    .BEHAVIOUR_SETTINGS.PREVENT_VIDEO_ADD_TO_TIMELINE_ON_VIDEO_ENCODER_PARAMS_MISMATCH || 0,
  ignoreQuantizerVideoParamsMismatch: __CFG__
    .BEHAVIOUR_SETTINGS.IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH || 0,
  autoPlaySelectedMedia: __CFG__
    .BEHAVIOUR_SETTINGS.AUTO_PLAY_SELECTED_MEDIA ?? 1,
} as const


export const VIEW_FORM_STATE = {
  showHeader: 1,
  showMenuTabs: 1,
  showProjectMedia: __CFG__
    .SOURCE_FILES_TYPES.PROJECT_MEDIA || 0,
  showMyMedia: __CFG__
    .SOURCE_FILES_TYPES.MEDIA || 0,
  showPreviewSplitButton: __CFG__
    .PREVIEW.SHOW_PREVIEW_SPLIT_BUTTON || 0,
  showPreviewSwitchButtons: __CFG__
    .PREVIEW.SHOW_PREVIEW_SWITCH_BUTTON || 0,
  showInOutPointsTimeline: __CFG__
    .SHOW_INOUT_POINTS_TIMELINE || 0,
  showInOutPointsSource: __CFG__
    .SHOW_INOUT_POINTS_SOURCE || 0,
  showDropPlaceHolderTimeline: __CFG__
    .SHOW_DROP_PLACE_HOLDER_TIMELINE || 0,
  lang: '',
} as const
